module.exports = "https://cdn.realtymogul.com/static/media/close_wht.49c20463.svg";